import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { PhoneInterface, TwilioIntegration, TwilioNumberSearchCriteria } from 'voxr-shared';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {
  private http = inject(HttpClient);

  constructor() { }

  createSubAccount(name?: string) {
    return firstValueFrom(this.http.post<TwilioIntegration>(`${environment.app.serviceUrl}/phone/twilio/assign`, { name }));
  }

  getIntegration() {
    return firstValueFrom(this.http.get<TwilioIntegration>(`${environment.app.serviceUrl}/phone/twilio/integration`));
  }
  registerIntegration(integration: TwilioIntegration) {
    return firstValueFrom(this.http.post<any>(`${environment.app.serviceUrl}/phone/twilio/register`, { integration }));
  }

  searchNumbers(integrationId: string, criteria: TwilioNumberSearchCriteria) {
    return firstValueFrom(this.http.post<any[]>(`${environment.app.serviceUrl}/phone/twilio/search`, { integrationId, criteria }));
  }
  buyNumber(integrationId: string, phoneNumber: string, replacePhoneId?: string) {
    return firstValueFrom(this.http.post<PhoneInterface>(`${environment.app.serviceUrl}/phone/twilio/buy-number`, { integrationId, phoneNumber, replacePhoneId }));
  }
  releaseNumber(phoneId: string) {
    return firstValueFrom(this.http.post<any>(`${environment.app.serviceUrl}/phone/twilio/release-number`, { phoneId }));
  }

  setInbound(numberId: string, provider: 'VOXR' | 'VAPI') {
    return firstValueFrom(this.http.post<any>(`${environment.app.serviceUrl}/phone/inbound/${numberId}`, { provider }));
  }

  getUnassignedPhones() {
    return firstValueFrom(this.http.post<PhoneInterface[]>(`${environment.app.serviceUrl}/phone/unassigned-phones`, null));
  }

  assignPhones(workspaceId: string, phoneIds: string[]) {
    return firstValueFrom(this.http.post<PhoneInterface[]>(`${environment.app.serviceUrl}/phone/assign`, { workspaceId, phoneIds }));
  }

  getWorkspacePhones(): PhoneInterface[] | PromiseLike<PhoneInterface[]> {
    return firstValueFrom(this.http.post<PhoneInterface[]>(`${environment.app.serviceUrl}/phone/workspace-phones`, null));
  }

  setTag(integrationId: string, phoneIds: string[], tag: string, mode: 'add' | 'remove') {
    return firstValueFrom(this.http.post<any>(`${environment.app.serviceUrl}/phone/tags/${integrationId}`, { tag, phoneIds, mode }));
  }

  setTrusthub(integrationId: string, phoneIds: string[], profileSid: string, productSid: string, action: 'assign' | 'unassign') {
    return firstValueFrom(this.http.post<PhoneInterface[]>(`${environment.app.serviceUrl}/phone/trusthub/${integrationId}/${action}`, { phoneIds, profileSid, productSid }));
  }
}
